import { Enum } from './Enum';

export class AppointmentType extends Enum {
  translationKey = 'appointmentType';

  static asArray: AppointmentType[] = [];

  static byKey: { [name: string]: AppointmentType } = {};

  static readonly SIX_MO_TEL = new AppointmentType('6 MO TEL');

  static readonly SIX_MO_VISIT = new AppointmentType('6 MO Visit');

  static readonly SIX_MO_VV = new AppointmentType('6 MO VV');

  static readonly SIX_MO_VV_ONE = new AppointmentType('6 MO VV 1');

  static readonly ACUTE = new AppointmentType('ACUTE');

  static readonly ACUTE_TEL = new AppointmentType('ACUTE TEL');

  static readonly ACUTE_VV = new AppointmentType('ACUTE VV');

  static readonly ANNU_TEL = new AppointmentType('ANNU TEL');

  static readonly ANNU_VV = new AppointmentType('ANNU VV');

  static readonly CCA_SIX_MO = new AppointmentType('CCA 6 MO');

  static readonly CCA_SIX_MO_1 = new AppointmentType('CCA 6 MO 1');

  static readonly ER = new AppointmentType('ER');

  static readonly ER_TEL = new AppointmentType('ER TEL');

  static readonly ER_VV = new AppointmentType('ER VV');

  static readonly EST_F_U = new AppointmentType('EST F/U');

  static readonly EST_TEL = new AppointmentType('EST TEL');

  static readonly EST_VV = new AppointmentType('EST VV');

  static readonly EST_VV_1 = new AppointmentType('EST VV 1');

  static readonly INT = new AppointmentType('INT');

  static readonly INT_VV = new AppointmentType('INT VV');

  static readonly PHARM_CON = new AppointmentType('PHARM CON');

  static readonly PSTHOSP = new AppointmentType('PSTHOSP');

  static readonly PSTHOSP_TE = new AppointmentType('PSTHOSP TE');

  static readonly PSTHOSP_VV = new AppointmentType('PSTHOSP VV');

  static readonly TCM = new AppointmentType('TCM');

  static readonly TCM_VV = new AppointmentType('TCM VV');

  constructor(public readonly value: string) {
    super();
    AppointmentType.asArray.push(this);
    AppointmentType.byKey[value] = this;
  }

  toString(): string {
    return this.value;
  }

  static isCalendarType(type: AppointmentType | string) {
    return [
      AppointmentType.ACUTE_VV.value,
      AppointmentType.ANNU_VV.value,
      AppointmentType.CCA_SIX_MO_1.value,
      AppointmentType.CCA_SIX_MO.value,
      AppointmentType.EST_VV.value,
      AppointmentType.INT_VV.value,
      AppointmentType.PSTHOSP_VV.value,
      AppointmentType.SIX_MO_VV_ONE.value,
      AppointmentType.SIX_MO_VV.value,
      AppointmentType.TCM_VV.value,
    ].includes(type.valueOf());
  }

  static isOnboardType(type: AppointmentType | string) {
    return type.valueOf().toLocaleUpperCase().startsWith('ONBRD');
  }

  static isPharmType(type: AppointmentType | string) {
    return type.valueOf().toLocaleUpperCase().startsWith('PHARM');
  }

  static isReportType(type: AppointmentType | string) {
    return [
      AppointmentType.ACUTE_TEL.value,
      AppointmentType.ANNU_TEL.value,
      AppointmentType.EST_TEL.value,
      AppointmentType.PSTHOSP_TE.value,
      AppointmentType.SIX_MO_TEL.value,
    ].includes(type.valueOf());
  }
}

export default AppointmentType;
